export const EN = "en"
export const NO = "no";